import dataCenter from '@/utils/store.js';


const fetch = function({commit, dispatch, state}, params) {
	return new Promise((resolve, reject) => {
        dataCenter.getChannelList(params).then((data) => {
 			commit({
 				type: 'ADDLIST',
 				lists: data
 			});
 			resolve(data);
        }, (status) => {
            reject(status);
        });
    });
};

export default {
    fetch
};



// WEBPACK FOOTER //
// ./src/vuex/channel/actions.js